import { apiClient } from "./client";
import { type Listing } from "./listings";

export interface WishlistItem {
  _id: string;
  userId: string;
  listingId: string;
  listing: Listing;
  dateAdded: string;
}

export interface WishlistResponse {
  items: WishlistItem[];
  totalItems: number;
}

class WishlistService {
  async getWishlist(userId: string): Promise<WishlistResponse> {
    const response = await apiClient.get<{
      listings: Listing[];
      page: number;
      totalPages: number;
    }>(`/users/${userId}/listings/favorites`);

    const items: WishlistItem[] = response.listings.map((listing) => ({
      _id: listing._id,
      userId: userId,
      listingId: listing._id,
      listing: listing,
      dateAdded: listing.datetime_scraped || new Date().toISOString(),
    }));

    return {
      items,
      totalItems: items.length,
    };
  }

  async addToWishlist(userId: string, listingId: string): Promise<WishlistItem> {
    await apiClient.post(`/users/${userId}/listings/favorites`, {
      listing_id: listingId,
    });

    return {
      _id: `${userId}-${listingId}`,
      userId: userId,
      listingId: listingId,
      listing: {} as Listing,
      dateAdded: new Date().toISOString(),
    };
  }

  async removeFromWishlist(userId: string, listingId: string): Promise<{ success: boolean }> {
    await apiClient.delete(`/users/${userId}/listings/favorites/${listingId}`);
    return { success: true };
  }

  async isInWishlist(userId: string, listingId: string): Promise<{ inWishlist: boolean }> {
    const response = await apiClient.get<{
      listings: Listing[];
    }>(`/users/${userId}/listings/favorites`);
    
    const inWishlist = response.listings.some(
      (listing) => listing._id === listingId
    );
    
    return { inWishlist };
  }
}

export const wishlistService = new WishlistService();

